{
  "label": "Organization",
  "rename": "Rename the organization",
  "dialogTitle": "Organization name",
  "nameLabel": "Name",
  "nameHint": "Visible to everyone in the organization — in the platform header and in notification emails",
  "saving": "Saving…"
}
